var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScChartLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 33,
    viewBox: "0 0 150 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0605469 11.6467L11.5789 5.7514L23.0973 3.64594L34.6157 1.11938L46.1341 9.54123L57.6524 5.33031L69.1708 13.7522L80.6892 14.5943L92.2076 10.8045L103.726 7.43577L115.244 4.48812L126.763 12.4889L138.281 16.6998L149.799 3.22485",
    stroke: "url(#paint0_linear_1506_12711)",
    strokeWidth: 1.29837
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1506_12711",
    x1: 74.93,
    y1: 16.6998,
    x2: 74.93,
    y2: 1.11938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C84CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10F1A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScChartLine);
export default __webpack_public_path__ + "static/media/sc-chart-line.90e0cef6cdc529af60a5b4bb939a6809.svg";
export { ForwardRef as ReactComponent };